import React, { useState, useEffect } from 'react';
import {
  Dropdown, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown,
} from 'reactstrap';
import { useLazyQuery, useMutation } from 'react-apollo';
import { useToasts } from 'react-toast-notifications';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import {
  ChangePassword, Logout, TermsService, PrivacyPolicy,
} from '../../modals';
import {
  handleGraphqlError, staticConstants, getLocalUserData, history, routeConstants, formatedCurrency, capitalizeEveryWord,
} from '../../../utils';
import UpdateProfileForm from '../updateProfile/UpdateProfileForm';
import {
  GET_USER_DATA_QUERY, GET_ALL_ARTIST_QUERY, GET_ACTIVE_ARTIST, GET_NOTIFICATION_SETTING, GET_REVENUE,
} from '../../../graphql-client/queries';
import {
  ACTIVE_ARTIST_MUTATION, REMOVE_MANAGER, NOTIFICATIONS, UPDATE_NOTIFICATION,
} from '../../../graphql-client/mutations';

import Loading from '../loadingOverlay/Loading';
import InvitationContainer from '../invitation/InvitationContainer';

function Settings(props) {
  const { routeParams, isQuestionnaireSkipped } = props;
  const userData = getLocalUserData();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [changePasswordModal, setChangePasswordModal] = useState(false);
  const [termsServiceModal, setTermsServiceModal] = useState(false);
  const [privacyPolicyModal, setPrivacyPolicyModal] = useState(false);
  const [signUpModal, setSignUpModal] = useState(false);
  const [logoutModal, setLogoutModal] = useState(false);
  const { addToast } = useToasts();
  const [invitationModal, setInvitationModal] = useState(false);
  const [removeUserId, setRemoveUserId] = useState();
  const [allArtists, setAllArtist] = useState();
  const [userDetail, setUserDetail] = useState();
  const [pushNotification, setPushNotification] = useState(true);
  const [emailNotification, setEmailNotification] = useState(true);
  const [revenueQuery, { data: revenueData, loading: revenueLoading }] = useLazyQuery(GET_REVENUE);
  const [notificationValue] = useMutation(NOTIFICATIONS, {
    variables: {
      notification: pushNotification,
      emailNotification,
    },
    onError(error) {
      addToast(handleGraphqlError(error), { appearance: 'error' });
    },
    onCompleted(data) {
      addToast(data.updateSettings.message, { appearance: 'success' });
    },
  });

  const [activeArtistQuery, { loading, data: activeArtistData },
  ] = useLazyQuery(GET_ACTIVE_ARTIST, { skip: userData?.role !== staticConstants.ROLE.MANAGER });

  const [getAllArtistQuery, {
    loading: artistQueryLoading, error: artistQueryError, data: allArtistsQueryData, refetch: refetchAllArtistQuery,
  },
  ] = useLazyQuery(GET_ALL_ARTIST_QUERY, { skip: userData?.role !== staticConstants.ROLE.MANAGER });

  const [activeArtistMutation] = useMutation(ACTIVE_ARTIST_MUTATION);

  const [getUserDataQury,
    { loading: getUserLoading, data: userDetailQueryData, refetch: refetchUser }] = useLazyQuery(GET_USER_DATA_QUERY, {
    fetchPolicy: 'network-only',
  });

  const [notificationQuery, { data: getNotificationData }] = useLazyQuery(GET_NOTIFICATION_SETTING, {});

  const [updateNotification] = useMutation(UPDATE_NOTIFICATION, {
    variables: {},
    update: () => {
      notificationQuery();
    },
  });

  /* Get data local cache */
  useEffect(() => {
    if (getNotificationData && getNotificationData.notification) {
      setPushNotification(getNotificationData.notification.notification);
      setEmailNotification(getNotificationData.notification.emailNotification);
    }
  }, [getNotificationData]);

  const [removeManagerMutation, { loading: removeManagerLoading }] = useMutation(REMOVE_MANAGER, {
    variables: { userId: removeUserId },
    onCompleted: (data) => {
      addToast(data.remove.message, { appearance: 'success' });
      refetchUser();
      if (userData.role === staticConstants.ROLE.MANAGER) {
        refetchAllArtistQuery();
      }
    },
    onError: (err) => {
      addToast(handleGraphqlError(err), { appearance: 'success' });
    },
  });

  useEffect(() => {
    activeArtistData && (() => {
      revenueQuery({ variables: { artistId: activeArtistData.activeArtist._id } });
      getUserDataQury({ userId: activeArtistData.activeArtist._id });
    })();
  }, [activeArtistData]);

  useEffect(() => {
    if (allArtistsQueryData && !activeArtistData) {
      const fData = allArtistsQueryData.getAllArtist.data.find((da) => {
        if (routeParams && routeParams.artistId) {
          return da._id === routeParams.artistId;
        }
        return da.isDefault;
      });
      fData && activeArtistMutation({ variables: fData });
    }
    allArtistsQueryData && setAllArtist(allArtistsQueryData.getAllArtist.data);
  }, [allArtistsQueryData, routeParams]);

  useEffect(() => {
    if (userData?.role === staticConstants.ROLE.MANAGER) {
      activeArtistQuery();
      getAllArtistQuery();
    } else {
      getUserDataQury();
      revenueQuery();
    }
  }, []);

  /* redirect to questioner */
  useEffect(() => {
    if (userDetailQueryData && userDetailQueryData.getUser) {
      updateNotification({
        variables: {
          notification: userDetailQueryData.getUser.data.notification,
          emailNotification: userDetailQueryData.getUser.data.emailNotification,
        },
      });
      setUserDetail(userDetailQueryData.getUser.data);
    }
    if (userDetailQueryData && userDetailQueryData.getUser && userDetailQueryData.getUser.data.category.length < 1) {
      if (!isQuestionnaireSkipped) {
        history.push(routeConstants.QUESTIONNAIRE);
      }
    }
  }, [userDetailQueryData]);

  useEffect(() => {
    removeUserId && removeManagerMutation();
  }, [removeUserId]);

  if (loading || revenueLoading || artistQueryLoading || getUserLoading || removeManagerLoading) {
    return <Loading active />;
  }
  if (artistQueryError) {
    return addToast(handleGraphqlError(artistQueryError), { appearance: 'error' });
  }

  const toggleChangePasswordModal = () => setChangePasswordModal(!changePasswordModal);
  const toggleEditProfileModal = () => setSignUpModal(!signUpModal);
  const toggleLogoutModal = () => setLogoutModal(!logoutModal);
  const toggleTermsServiceModal = () => setTermsServiceModal(!termsServiceModal);
  const togglePrivacyPolicyModal = () => setPrivacyPolicyModal(!privacyPolicyModal);
  const toggleInvitationModal = (isOpen) => setInvitationModal(isOpen);
  const setActiveArtist = (artist) => activeArtistMutation({ variables: artist });

  const handleRemoveArtist = (artistId) => {
    activeArtistData.activeArtist._id === artistId && setActiveArtist(allArtists.find((artist) => artist._id !== artistId));
    setRemoveUserId(artistId);
  };
  const toggle = () => {
    setDropdownOpen((prevState) => !prevState);
    document.body.classList.toggle('sm-overflow-hidden');
  };

  const renderArtistListing = (artists) => artists.map((artist) => (
    <UncontrolledDropdown key={artist._id}>
      <DropdownToggle>
        <span
          className={`artist-image ${activeArtistData && activeArtistData.activeArtist._id === artist._id ? 'active' : ''}`}
          key={Math.random()}
          data-tip={capitalizeEveryWord(artist.name)}
          data-place="bottom"
          data-background-color="#fff"
          data-text-color="#000"
        >
          <img
            src={artist.artistImage}
            alt="Artist"
            className="image-cover"
          />
          <ReactTooltip effect="solid" />
        </span>
      </DropdownToggle>
      <DropdownMenu right className="dropdown-theme user-switch-dropdown">
        <DropdownItem onClick={() => setActiveArtist(artist)}>
          {activeArtistData.activeArtist._id !== artist._id ? 'Switch dashboard' : 'Current Artist dashboard'}
          {' '}

        </DropdownItem>
        {activeArtistData && artists.length > 1
          && (
            <DropdownItem onClick={() => {
              handleRemoveArtist(artist._id);
            }}
            >
              Remove this Artist
            </DropdownItem>
          )}
      </DropdownMenu>
    </UncontrolledDropdown>
  ));

  const renderRevenueSection = () => (
    <div className={`switch-artist-wrapper ${userData?.role === staticConstants.ROLE.ARTIST ? 'p-0' : ''}`}>
      <p className={`revenue-text ${userData?.role === staticConstants.ROLE.ARTIST ? 'mb-3' : ''}`}>
        <em />
        {' '}
        {revenueData && `Total revenue generated $${formatedCurrency(revenueData.getRevenue.data.totalRevenue)}`}
      </p>
      <div className="artist-profile active">
        {allArtists && activeArtistData
          && renderArtistListing(allArtists)}
      </div>

      {userData?.role === staticConstants.ROLE.ARTIST && userDetail && userDetail.managerId
        && (
          <div className="switch-manager-wrapper">
            <div className="manager-image">
              <img
                src={userDetail.managerId.managerImage}
                className="image-cover"
                alt="label"
              />
            </div>
            <div className="manager-info">
              <h4>{`${userDetail.managerId.managerFirstName} ${userDetail.managerId.managerLastName}`}</h4>
              <p>{userDetail.managerId.managerFirstName}</p>
              <button type="button" className="btn" onClick={removeManagerMutation}>Remove label</button>
            </div>
          </div>
        )}
    </div>
  );

  const handleNotifications = (notificationType) => {
    const prepQuery = {
      notification: pushNotification,
      emailNotification,
    };
    if (notificationType === 'push') {
      setPushNotification(!pushNotification);
      prepQuery.notification = !pushNotification;
    } else if (notificationType === 'email') {
      setEmailNotification(!emailNotification);
      prepQuery.emailNotification = !emailNotification;
    }
    updateNotification({ variables: prepQuery });
    setTimeout(() => {
      notificationValue();
    }, 1);
  };

  const renderNotificationSettings = () => (
    <div className="notification-setting">
      <h3>Notification settings</h3>
      <p>Please note when choosing to turn off notifications BYGMusic admin will not remind you of campaign opportunity or due dates.</p>
      <div className="checkbox-row">
        <em>Email notifications</em>
        <div className="custom-control custom-switch">
          <input
            type="checkbox"
            name="customSwitch1"
            className="custom-control-input"
            checked={emailNotification}
            id="customSwitch1"
            onClick={() => handleNotifications('email')}
          />
          <label className="custom-control-label" htmlFor="customSwitch1" />
        </div>
      </div>
      <div className="checkbox-row">
        <em>push notifications</em>
        <div className="custom-control custom-switch">
          <input type="checkbox" name="customSwitch2" className="custom-control-input" checked={pushNotification} id="customSwitch2" onClick={() => handleNotifications('push')} />
          <label className="custom-control-label" htmlFor="customSwitch2" />
        </div>
      </div>
    </div>
  );
  return (
    <div>
      <Dropdown isOpen={dropdownOpen} toggle={toggle} className="profile-dropdown-wrap">
        <DropdownToggle className="dropdown-head-button">
          <span className="icon icon-settings" />
        </DropdownToggle>
        <DropdownMenu right className="profile-dropdown">
          <DropdownItem className="close-dropdown icon icon-cross" />
          {
            userData?.role === staticConstants.ROLE.MANAGER && !activeArtistData
            && (
              <DropdownItem onClick={() => toggleInvitationModal(true)}>
                Invite Artist
              </DropdownItem>
            )
          }
          {((userDetail && userDetail.category && userDetail.category.length > 0) || (userDetail?.isQuestionnaireSkipped)) && (
            <>
              <DropdownItem header className={userData?.role === staticConstants.ROLE.ARTIST ? 'm-0' : ''}>
                Profile settings
              </DropdownItem>
              {renderRevenueSection()}
              {userDetail && !userDetail.managerId
                && userData?.role === staticConstants.ROLE.ARTIST && (
                  <DropdownItem onClick={() => toggleInvitationModal(true)}>
                    Invite Label
                  </DropdownItem>
              )}

              {userDetail && userData?.role === staticConstants.ROLE.MANAGER
                && (
                  <DropdownItem onClick={() => toggleInvitationModal(true)}>
                    Invite Artist
                  </DropdownItem>
                )}

              <DropdownItem onClick={toggleEditProfileModal}>Edit Profile</DropdownItem>
              <DropdownItem onClick={() => { history.push(routeConstants.QUESTIONNAIRE, { editMode: true }); }}>Edit interests</DropdownItem>
            </>
          )}
          <DropdownItem onClick={toggleChangePasswordModal}>Change password</DropdownItem>
          <DropdownItem onClick={toggleTermsServiceModal}>terms of service</DropdownItem>
          <DropdownItem onClick={togglePrivacyPolicyModal}>privacy policy</DropdownItem>
          {renderNotificationSettings()}
          <DropdownItem className="dropdown-item-logout" onClick={toggleLogoutModal}>Sign out</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      { signUpModal
        && <UpdateProfileForm isOpen={signUpModal} onClose={toggleEditProfileModal} />}
      { changePasswordModal
        && (
          <ChangePassword
            isOpen={changePasswordModal}
            onClose={() => { toggleChangePasswordModal(); }}
          />
        )}
      { logoutModal && (
        <Logout
          isOpen={logoutModal}
          onClose={() => { toggleLogoutModal(); }}
        />
      )}

      { invitationModal && (
        <InvitationContainer
          isOpen={invitationModal}
          onClose={() => toggleInvitationModal(false)}
        />
      )}
      {termsServiceModal && (
        <TermsService
          isOpen={termsServiceModal}
          onClose={() => { toggleTermsServiceModal(); }}
        />
      )}
      {privacyPolicyModal && (
        <PrivacyPolicy
          isOpen={privacyPolicyModal}
          onClose={() => { togglePrivacyPolicyModal(); }}
        />
      )}
    </div>
  );
}

Settings.propTypes = {
  routeParams: PropTypes.shape({ artistId: PropTypes.string, offerId: PropTypes.string, tabId: PropTypes.string }),
};

Settings.defaultProps = {
  routeParams: null,
};
export default Settings;
